import enums from "./../enums";
import Service from "./../service/index.jsx";

export function getDocumentStatus(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.WITHDRAW_LOADING, payload: true });
		Service.get("document-api", "documents/hasunapproveddocument", params)
			.then((response) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				dispatch({
					type: enums.UNAPPROVED_DOCUMENT,
					payload: response.data.hasUnapprovedDocument,
				});
				dispatch({ type: enums.MISSING_DOCUMENT, payload: response.data.missingDocument });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				console.log(e);
			});
	};
}

export function getActiveWithdrawMethods(cb) {
	return (dispatch) => {
		dispatch({ type: enums.WITHDRAW_LOADING, payload: true });
		Service.get("payment-api", "methods/active/Withdraw")
			.then((response) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				dispatch({
					type: enums.WITHDRAW_PAYMENT_METHODS,
					payload: response.data.paymentMethods,
				});
				cb?.(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				console.log(e);
			});
	};
}

export function withdraw(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.WITHDRAW_LOADING, payload: true });
		Service.post("account-api", "withdraw", data)
			.then((response) => {
				if (
					window.SUMSUB_ID_VERIFICATION &&
					"message" in response.data &&
					"weblink" in response.data.message
				) {
					cb(response.data);
					return;
				}

				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "success",
						msg: "SUCCESSFULL_WITHDRAW",
						title: "SUCCESSFULL_TITLE",
					},
				});
				cb(response.data);
			})
			.catch((e) => {
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg:
							e.response.data.message ===
							"Cannot read property 'accessToken' of undefined"
								? "ACCESS_TOKEN_ERROR"
								: e.response.data.message === "Insufficient Balance!"
									? "INSUFFICIENT_BALANCE"
									: e.response.data.message,
						title: "ERROR",
					},
				});
				cb(e);
			})
			.finally(() => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
			});
	};
}

export function getOdendibilTypes(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.WITHDRAW_LOADING, payload: true });
		Service.post("payment-api", "odendibil/getwithdrawtypes", data)
			.then((response) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				dispatch({ type: enums.ODENDIBIL_TYPES, payload: response.data.result });
			})
			.catch((e) => {
				dispatch({ type: enums.WITHDRAW_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
				cb(e);
			});
	};
}

//method [ columbia, spei, argentina, chile ]
//currency [ MXN, USD, COP, ARS, CLP ]
//operation [payout]
export function getMonetixBanks({ amount, currency, method, operation = "payout" }) {
	return Service.post("payment-api", "monetix/banks", { amount, currency, method, operation });
}
export function getTurbohavaleBanks() {
	return Service.get("payment-api", "turbohavale/banks");
}
export function getNuveiSpeiBankList() {
	return Service.get("payment-api", "nuvei/banklist");
}

//monetix cards
export function getMonetixCards() {
	return Service.get("payment-api", "monetix/cards");
}

export function tokenizeMonetixCard({ card_number, expiry_month, expiry_year, card_holder, type }) {
	return Service.post("payment-api", "monetix/card/tokenize", {
		card_number,
		expiry_month,
		expiry_year,
		card_holder,
		type,
	});
}
